module.exports = __webpack_public_path__ + "img/genoa-empoli.e3cd7260.jpg";